import { QualityOptions, ShowroomUserViewShareUi } from 'generated/graphql';

const initialState: ShowroomUserViewShareUi = {
	isDialogOpen: false,
	mediaQuality: QualityOptions.Screen
};

export default initialState; 